export default "/images/vendor/flag-icon-css/flags/4x3/be.svg?410c4acc521ec3a598361eacbb8e1557";